import { render, staticRenderFns } from "./MerchantSettings.vue?vue&type=template&id=15056a73&scoped=true&"
import script from "./MerchantSettings.vue?vue&type=script&lang=js&"
export * from "./MerchantSettings.vue?vue&type=script&lang=js&"
import style0 from "./MerchantSettings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MerchantSettings.vue?vue&type=style&index=1&id=15056a73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15056a73",
  null
  
)

export default component.exports